<gen-dynamic-form [formConfig]="config"
                  [formName]="fromId"
                  [stayInFormMode]="true"
                  [disabled] = "widgetDisabledStatus"
                  [listenToDataChange]="true"
                  [submitted]="widgetFormInstanceSubmitted"
                  (formChange) = "updateSearchObject($event.form)"
                  (formInit)="updateSearchObject($event,true)"
                  [resetForm]="restForm"
                  [formData]="data">
</gen-dynamic-form>